import { AddFilesModal, type AddFilesModalInitialTab } from '@/chat-common/components/source-dialogs/AddFilesModal'
import { kMedSummaryAssetAcceptedFileTypes } from '../../constants'

const kSupportedContentTypes = new Set(Object.keys(kMedSummaryAssetAcceptedFileTypes))

type AddFilesMatterFilesDialogProps = {
  open: boolean
  matterId: string | null
  initialSelectedIds: string[]
  initialTab?: AddFilesModalInitialTab
  onClose: () => void
  onApply: (userFileIds: string[]) => void
}

/**
 * Matter Files picker for the billing summary Add Files page. Thin wrapper over the shared
 * {@link AddFilesModal}, restricted to the types the extraction pipeline supports (PDF plus
 * the convertible types: DOCX and common images — AI-94). The shared modal already gates
 * non-completed files out of selection, so this wrapper only adds the type rule on top.
 */
export function AddFilesMatterFilesDialog({ open, matterId, initialSelectedIds, initialTab, onClose, onApply }: AddFilesMatterFilesDialogProps) {
  // AddFilesModal requires a non-null matterId; there is nothing to browse without one.
  if (!matterId) return null

  return (
    <AddFilesModal
      open={open}
      matterId={matterId}
      initialSelectedFileIds={initialSelectedIds}
      initialTab={initialTab}
      onClose={onClose}
      onFilesSelected={onApply}
      isFileSelectable={(file) => kSupportedContentTypes.has(file.detected_content_type ?? '')}
      fileNotSelectableMessage="Unsupported type. Billing summaries extract PDFs, Word documents, and images."
    />
  )
}
